import React, { useState } from "react";
import axios from "axios";
import Button from "../../../../iconosv0/src/components/Button/Button.jsx";
import "./../stylesloin.scss";

export default function ElementRequestOTP({ t }) {
  const tr = (k, fb) => (typeof t === "function" ? t(k) : fb);
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [sending, setSending] = useState(false);

  const sendOTP = async (e) => {
    e.preventDefault();
    setMsg("");
    try {
      setSending(true);
      const res = await axios.post(`${process.env.REACT_APP_API_BASE}/send-otp`, { email });
      setMsg(res?.data?.message || tr("otpSent","OTP sent."));
      // console.log("OTP:", res?.data?.otp); // if backend returns it in dev
    } catch (err) {
      setMsg(tr("errorSendingOTP","Error sending OTP"));
      console.error(err);
    } finally {
      setSending(false);
    }
  };

  return (
    <main className="auth">
      <span aria-hidden className="page-bottom-glow" />
      <section className="container auth__container">
        <header className="auth__header">
          <h1>{tr("requestOtpTitle","Request a one-time code")}</h1>
          <p>{tr("requestOtpSubtitle","We’ll email the code to you.")}</p>
        </header>

        <form className="auth__card" onSubmit={sendOTP}>
          <div className="field">
            <label htmlFor="otp-email">{tr("emailLabel","Email")}</label>
            <input
              id="otp-email"
              type="email"
              placeholder={tr("enterEmailPlaceholder","Enter your email")}
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <Button
            className="btn-primary w-full"
            state={sending ? "loading" : "default"}
            type="primary"
            icon={false}
            size="default"
            text={tr("sendOTP","Send OTP")}
            disabled={sending}
          />

          {msg ? <p className="auth__message">{msg}</p> : null}
        </form>
      </section>
    </main>
  );
}
